<nb-card class="content-view">
  <nb-card-body>
    <ngx-view-notifications (onClose)="close()"></ngx-view-notifications>
  </nb-card-body>
</nb-card>
